import { CircularProgress } from "@mui/material";

export default function CustomCircularProgress() {
  return <CircularProgress className="custom-circular-progress" />;
}
